import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { Message, SpinnerService } from 'shared-components';

@Component({
    selector: 'app-porciones-envase',
    templateUrl: './porciones-envase.component.html'
})
export class PorcionesEnvaseComponent implements OnInit {

    @Input() porcionesEnvase;

    constructor() {}

    ngOnInit() {
    }

}
